module.exports = __webpack_public_path__ + "static/Roboto-Regular-b71fa9778e09a4b2a3c6e1b829eaea3c.woff";